import { useAppDispatch } from 'hooks'
import { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { setIsLoggedIn } from 'redux/store/slices/authSlice'
import TokenService from 'services/token.service'

const useGenerateQRLink = () => {
  const dispatch = useAppDispatch()

  const [searchParams] = useSearchParams()

  const generatedLink = useMemo(() => {
    const token = TokenService.getAccessToken()
    if (!token) throw new Error('Token is not found')
    const url = window.location
    const q = new URLSearchParams(window.location.search)
    q.set('token', token)

    return `${url.origin}${url.pathname}?${q.toString()}`
  }, [])

  useEffect(() => {
    const token = searchParams.get('token')

    if (token) {
      TokenService.setJWTTokens({ access: token, refresh: '' })
      dispatch(setIsLoggedIn(true))
    }
  }, [dispatch, searchParams])

  return generatedLink
}

export { useGenerateQRLink }
